import { withInstall } from '../utils'
import _InputNumber from './InputNumber'
import './index.scss'
export const InputNumber = withInstall(_InputNumber)
export default InputNumber
